import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "../src/Redux/store";
//import { Provider } from "react-redux";
import { BrowserRouter  } from "react-router-dom";
//import axios from "axios";
//import dotenv from 'react-dotenv';
//dotenv.config();
//console.log(process.env.REACT_APP_API);
//axios.defaults.baseURL = process.env.REACT_APP_API || 'http://localhost:3001';

ReactDOM.render(
   <React.StrictMode>
    {/* <Provider store={store}> */}
      <BrowserRouter>
        <App />
       
      </BrowserRouter>
    {/* </Provider>  */}
   </React.StrictMode>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
